import React, { useEffect, useRef } from "react";
import "./RevealSection.css";

// delay (ms) lets callers stagger multiple RevealSections
function RevealSection({ children, delay = 0, id }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (delay) el.style.transitionDelay = `${delay}ms`;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("revealed");
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);

  return (
    <div ref={ref} className="reveal-section" id={id}>
      {children}
    </div>
  );
}

export default RevealSection;
